<template>
  <div id="my-tab">
    <Tabs ref="tab" type="card" closable v-model="activeTag" @on-click="handleClickTag" @on-tab-remove="handleRemoveTak"
      @on-contextmenu="handleContextMenu">
      <TabPane label="首页" v-if="!hasWorkbench" :closable="false" name="/home" context-menu />
      <TabPane label="工作台" v-if="hasWorkbench" :closable="false" name="/workbench" context-menu />
      <TabPane v-for="item in tagList" :key="item.path" :label="item.meta.title" :name="item.fullPath" context-menu />
      <template slot="contextMenu">
        <DropdownItem @click.native="closeAll">全部关闭</DropdownItem>
        <DropdownItem @click.native="closeRight">关闭右侧</DropdownItem>
        <DropdownItem @click.native="closeOther">关闭其他</DropdownItem>
      </template>
    </Tabs>
  </div>
</template>
<script>
import { saveBrowseLog } from '@/api/index'
export default {
  name: 'tag-list',
  data() {
    return {
      activeTag: null,
      contextData: null
    }
  },
  computed: {
    tagList() {
      return this.$store.getters.tagList || []
    },
    hasWorkbench() {
      return this.$bp.includes('srm:workbench:detail')
    }
  },
  watch: {
    tagList: {
      handler(val) {
        window.localStorage.setItem('tagList', JSON.stringify(val))
      },
      deep: true,
    },
    $route: {
      handler(val) {
        let item = this.tagList.find((item) => item.name === val.name)
        if (!item && val.path !== '/home' && val.path !== '/workbench') {
          this.$store.dispatch('pushTagList', val)
          this.saveBrowseLog(val.meta.title)
        }
        this.activeTag = val.fullPath
      },
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs.tab.scrollToActiveTab()
    }, 500)
  },
  methods: {
    closeAll() {
      this.$store.dispatch('clearTag')
      if (this.hasWorkbench) {
        this.$router.replace('/workbench')
      } else {
        this.$router.replace('/home')
      }
    },
    closeRight() {
      let index = this.tagList.findIndex(item => item.fullPath === this.contextData)
      this.$store.dispatch('clearTagRight', index)
      let item = this.tagList.find(item => item.fullPath === this.$route.fullPath)
      if (!item) {
        this.$router.replace(this.contextData)
      }
    },
    closeOther() {
      this.$store.dispatch('clearTagOther', this.contextData)
      this.$router.replace(this.contextData)
    },
    handleContextMenu(data) {
      this.contextData = data.name
      console.log(this.contextData, data)
    },
    handleRemoveTak(fullPath) {
      this.$store.dispatch('closeRoute', fullPath)
      if (this.activeTag !== this.$route.fullPath) {
        this.$router.replace(this.activeTag)
      }
    },
    handleClickTag(path) {
      this.$router.push(path)
    },
    async saveBrowseLog(name) {
      await saveBrowseLog({ message: '浏览' + name })
    },
  },
}
</script>
<style lang="less">
#my-tab {
  margin-left: 15px;
  .ivu-tabs-tab {
    border: none;
    margin-right: 14px;
    &:hover {
      background-color: #fff;
    }
  }
  .ivu-tabs-bar {
    border-bottom: none;
    margin-bottom: 4px
  }
  .ivu-tabs-tab-active {
    color: #001E28;
  }
}
</style>
